import {AppReflowRuleType} from '@wix/wixstores-client-core/dist/es/src/constants';

export type RuleDef = {
  type: AppReflowRuleType;
  values: string[];
};

export enum BiStoresReflowPageName {
  ProductPage = 'product page',
  CategoryPage = 'category page',
}
